<template>
  <modal
    name="auth-modal"
    transition="pop-out"
    :width="modalWidth"
    :focus-trap="true"
    :height="500"
    @opened="modalOpened"
    @closed="modalClosed"
  >
    <div class="form">
      <ul class="tab-group">
        <li class="tab" :class="{ active: formTab == 0 }">
          <div @click="tabSignup">Sign Up</div>
        </li>
        <li class="tab" :class="{ active: formTab == 1 }">
          <div @click="tabLogin">Log In</div>
        </li>
      </ul>
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div id="signup" v-if="formTab == 0">
            <h1>Sign Up For Free</h1>
            <form @submit.prevent="signup" autocomplete="off">
              <div class="field-wrap">
                <label
                  :class="{
                    active: emailActive,
                    highlight: emailHighlighted,
                  }"
                >
                  Email Address<span class="req">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  autocomplete="off"
                  minlength="8"
                  maxlength="75"
                  @input="(evt) => (email = evt.target.value)"
                  @focus="emailFocused()"
                  @blur="emailBlurred()"
                  @keyup.stop="emailKeyup()"
                />
              </div>

              <div class="field-wrap">
                <label
                  :class="{
                    active: passwordActive,
                    highlight: passwordHighlighted,
                  }"
                >
                  Set A Password<span class="req">*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  required
                  autocomplete="off"
                  minlength="8"
                  maxlength="50"
                  @input="(evt) => (password = evt.target.value)"
                  @focus="passwordFocused()"
                  @blur="passwordBlurred()"
                  @keyup="passwordKeyup()"
                />
              </div>

              <div class="error">{{ error }}</div>

              <button type="submit" class="button button-block">
                Get Started
              </button>
            </form>
          </div>
          <div id="login" key="1" v-else-if="formTab == 1">
            <h1>Welcome back</h1>
            <form @submit.prevent="login" autocomplete="off">
              <div class="field-wrap">
                <label
                  :class="{
                    active: emailActive,
                    highlight: emailHighlighted,
                  }"
                >
                  Email Address<span class="req">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  autocomplete="off"
                  minlength="8"
                  maxlength="75"
                  @input="(evt) => (email = evt.target.value)"
                  @focus="emailFocused()"
                  @blur="emailBlurred()"
                  @keyup="emailKeyup()"
                />
              </div>

              <div class="field-wrap">
                <label
                  :class="{
                    active: passwordActive,
                    highlight: passwordHighlighted,
                  }"
                >
                  Password<span class="req">*</span>
                </label>
                <input
                  type="password"
                  name="password"
                  required
                  autocomplete="off"
                  minlength="8"
                  maxlength="50"
                  @input="(evt) => (password = evt.target.value)"
                  @focus="passwordFocused()"
                  @blur="passwordBlurred()"
                  @keyup="passwordKeyup()"
                />
              </div>

              <div class="error">{{ error }}</div>

              <button type="submit" class="button button-block">Log In</button>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "LoginModal",
  data() {
    return {
      modalWidth: 0,
      error: "",
      email: "",
      password: "",
      loading: false,
      formTab: 0,
      emailActive: false,
      emailHighlighted: false,
      passwordActive: false,
      passwordHighlighted: false,
    };
  },
  created() {
    const winWidth = window.innerWidth;
    if (winWidth > 1200) {
      this.modalWidth = 500;
      return;
    }

    var widthPercentage = 0.0;
    if (winWidth >= 978) {
      widthPercentage = 0.3;
    } else if (winWidth >= 768) {
      widthPercentage = 0.5;
    } else if (winWidth >= 500) {
      widthPercentage = 0.5;
    } else if (winWidth >= 375) {
      widthPercentage = 0.8;
    } else if (winWidth >= 350) {
      widthPercentage = 0.85;
    } else {
      widthPercentage = 0.9;
    }
    this.modalWidth = winWidth * widthPercentage;
  },
  methods: {
    tabSignup() {
      this.resetInputs();
      this.formTab = 0;
    },
    tabLogin() {
      this.resetInputs();
      this.formTab = 1;
    },
    resetInputs() {
      this.emailActive = false;
      this.emailHighlighted = false;
      this.passwordActive = false;
      this.passwordHighlighted = false;
      this.email = "";
      this.password = "";
      this.error = "";
    },
    emailFocused() {
      this.emailHighlighted = this.email !== "";
    },
    emailBlurred() {
      this.emailHighlighted = false;
      if (this.email === "") {
        this.emailActive = false;
      }
    },
    emailKeyup() {
      this.emailHighlighted = this.email !== "";
      this.emailActive = this.email !== "";
    },
    passwordFocused() {
      this.passwordHighlighted = this.password !== "";
    },
    passwordBlurred() {
      this.passwordHighlighted = false;
      if (this.password === "") {
        this.passwordActive = false;
      }
    },
    passwordKeyup() {
      this.passwordHighlighted = this.password !== "";
      this.passwordActive = this.password !== "";
    },
    login() {
      if (this.isValidEmail() && this.isValidPassword()) {
        this.$store
          .dispatch("auth/login", {
            email: this.email,
            password: this.password,
          })
          .then(
            (response) => {
              console.log("Successfully logged in");
              this.trackEvent("Auth", "Login", this.email);
            },
            (error) => {
              const message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              console.log("Error logging in: " + message);
              this.error = "Incorrect email or password";
            }
          );
      } else {
        if (this.isValidEmail() && !this.isValidPassword()) {
          this.error = "Your password must be at least 8 chars long";
        } else {
          this.error = "Please enter a valid email.";
        }
      }
    },
    signup() {
      if (this.isValidEmail() && this.isValidPassword()) {
        this.$store
          .dispatch("auth/register", {
            email: this.email,
            password: this.password,
          })
          .then(
            (response) => {
              this.trackEvent("Auth", "Signup", this.email);
              console.log("Successfully registered");
            },
            (error) => {
              const message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              console.log("Error signing up: " + message);
              if (
                message ===
                "Password must be 8-32 in length, uppercase and lowercase, with at least 1 digit."
              ) {
                this.error = message;
              } else {
                this.error = "There was an error signing up...";
              }
            }
          );
      } else {
        if (this.isValidEmail() && !this.isValidPassword()) {
          this.error = "Your password must be at least 8 chars long";
        } else {
          this.error = "Please enter a valid email.";
        }
      }
    },
    modalOpened() {
      document.body.classList.add("modal-open");
      document.querySelector("header").classList.add("modal-open");
    },
    modalClosed() {
      document.body.classList.remove("modal-open");
      document.querySelector("header").classList.remove("modal-open");
    },
    isValidEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return (
        this.email.length >= 6 && re.test(this.email) && this.email.length <= 75
      );
    },
    isValidPassword() {
      return this.password.length >= 8 && this.password.length <= 50;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  div {
    text-decoration: none;
    color: $main;
    transition: 0.5s ease;
    &:hover {
      color: $main-dark;
    }
  }
}
.tab-group {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  li div {
    display: block;
    text-decoration: none;
    padding: 15px;
    background: rgba($gray-light, 0.25);
    color: $gray-light;
    font-size: 20px;
    float: left;
    width: 50%;
    text-align: center;
    cursor: pointer;
    transition: 0.5s ease;
    &:hover {
      background: $main-dark;
      color: white;
    }
  }
  .active div {
    background: $main;
    color: white;
  }
}
.tab-content {
  display: flex;
  flex: 1;
}
#signup {
  display: flex;
  flex-direction: column;
  flex: 1;
}
#login {
  display: flex;
  flex-direction: column;
  flex: 1;
}
form {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.form {
  // background: rgba($form-bg, 0.9);
  // background: hsl(225deg 2% 91% / 90%);
  background: #efefef;
  padding: 20px;
  border-radius: $br;
  height: 100%;
  box-shadow: 0 4px 10px 4px rgba($form-bg, 0.3);
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    padding: 35px;
  }
}
.form-inputs {
  flex: 1;
}
.button {
  border: 0;
  outline: none;
  border-radius: 0;
  padding: 30px 0;
  text-transform: uppercase;
  background: #2e76d0;
  color: white;
  transition: all 0.5s ease;
  height: 50px;
  margin: 0;
  line-height: 5px;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  &:hover,
  &:focus {
    background: $main-dark;
  }
}
.button-block {
  display: block;
  width: 100%;
}
textarea {
  border: 2px solid $gray-light;
  resize: vertical;
}
.field-wrap {
  position: relative;
  margin-bottom: 40px;
}
h1 {
  text-align: center;
  color: #262626;
  font-weight: $thin;
  margin: 0 0 40px;
}
label {
  position: absolute;
  transform: translateY(3px);
  -ms-transform: translateY(3px);
  -webkit-transform: translateY(3px);
  left: 11px;
  color: rgba(0, 0, 0, 0.5);
  transition: all 0.1s ease;
  -webkit-transition: all 0.1s ease;
  pointer-events: none;
  font-size: 20px;
  top: 2px;
  .req {
    margin: 2px;
    color: $main;
  }
}
label.active {
  transform: translateY(41px);
  -ms-transform: translateY(41px);
  -webkit-transform: translateY(41px);
  left: 2px;
  font-size: 14px;
  .req {
    opacity: 0;
  }
}
label.highlight {
  color: #262626;
}
input,
textarea {
  font-size: 22px;
  display: block;
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  background: none;
  background-image: none;
  border: 1px solid $gray-light;
  color: #262626;
  border-radius: 0;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  &:focus {
    outline: 0;
    border-color: $main;
  }
}
.error {
  text-align: center;
  color: #ff0000;
  font-weight: 700;
  margin-bottom: 25px;
}

// .auth-form {
//   overflow: hidden;
//   height: 100%;
//   color: #111;
//   font-weight: 600;
//   padding: 10px;
//   display: flex;
//   flex-direction: column;
//   align-content: center;
//   form {
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;
//   }
// }
// .title {
//   width: 100%;
//   padding: 10px;
//   text-align: center;
//   letter-spacing: 1px;
//   font-size: 1.2rem;
//   font-weight: 500;
//   color: #333;
//   margin-bottom: 0;
//   padding-bottom: 5px;
// }
// .inputs {
//   text-align: left;
//   margin: 24px;
//   margin-top: 0;
//   margin-bottom: 12px;
//   color: #333;
//   display: block;
//   label {
//     font-size: 15px;
//     margin-bottom: 5px;
//     margin-top: 5px;
//     &:first-child {
//       margin-top: 18px;
//     }
//   }
//   .form-input {
//     font-size: 14px;
//     font-weight: 400;
//     border: 1px solid rgba(0, 0, 0, 0.1);
//     border-radius: 4px;
//     width: 100%;
//     padding: 6px 12px;
//     background-color: #fafafa;
//     display: block;
//     height: 42px;
//   }
//   .input-problem {
//     font-size: 11px;
//     margin-top: 8px;
//     font-weight: 400;
//     height: 18px;
//     &.error {
//       text-align: center;
//       font-weight: 700;
//       color: #ef4d0a;
//       margin-top: 18px;
//     }
//   }
// }
// .submits {
//   margin: 0 24px;
// }
// button {
//   font-size: 13px;
//   font-weight: 600;
//   display: flex;
//   align-self: center;
//   margin: 15px 0;
//   width: 100%;
//   height: 32px;
//   padding: 7px 0;
//   justify-content: center;
//   align-items: center;
//   line-height: 30px;
//   border-radius: 5px;
//   background: #1e3264;
//   cursor: pointer;
//   color: black;
//   transition: box-shadow 0.4s;
// }
// .footer {
//   margin-top: 16px;
//   text-align: center;
// }

.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}
.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
